// extracted by mini-css-extract-plugin
export default {"delete-button":"ProfilePreferences_delete-button__eSDDz","preferences-label":"ProfilePreferences_preferences-label__VFiia","name-text":"ProfilePreferences_name-text__Ur78B"};